import Typewriter from 'typewriter-effect/dist/core';
import io from 'socket.io-client';
import "./style.css";
import html2canvas from 'html2canvas';
import canvas2image from "canvas2image-2";

function chatbot({loginDetails, socketData }){
    
    function chatBotTemplate(){
        return  `
        <div class="widget-content resizable">
            <div class='resizers'>
                <div class='resizer top-left'></div>
            </div>
        <!-- =========================

            Widget HTML code start

        ============================ -->
        <div id="chat-titlebar" class="titlebar">
            <div class="chatbox-header-left">
                <div class="chatbox-avatar"><img alt="" class="chakra-image css-0" src="https://unpkg.com/evalueserve-chatbot-ui@1.0.19/chatbot-header.png">
                </div>
                <div class="chatbox-user">
                    <div class="chatbox-user-name"><span id="chatbot-title-name">ChatBot</span> <span id="connectivity-status" class="circle offline"></span></div>
                </div>
            </div>
        </div>

        <div id="chat-container" class="container display-none">
        
                <div id="chats" class="chats hidechat">
                    
                </div>
                <div id="chats-hidden" style="display:none">
                </div>
                <span id="typing-text" class="typing-text hidetypingtext">Typing....</span>
                <form id="chatbotform" class="sendMessage disable-form">
                    
                    <div style="overflow: hidden; padding-right: .5em;flex-grow: 1;">
                    <input class="search-box" placeholder="Type here.." type="text" style="padding: 10px 10px;
                    font-size: 14px;
                    width: 100%;
                    box-sizing: border-box;
                    border: none;outline: none;" />
                    </div>
                    <button type="submit" class="send-message-btn"><span class="icon-send-icon"></span></button>
                    <button type="button" title="Reset Chat" id="reset-chat-button" class="cancle-chat-btn"/><span class="icon-redo"></span></button>
                    <button type="button" style="pointer-events: all !important;" id="disconnect-chat-button" class="cancle-chat-btn"/><span class="icon-cross"></span></button>
                    
                    <span style="pointer-events: all !important;" class="drop-up">
                        <span class="drop-up-item">
                            <button class="cancle-chat-btn" type="button"><i class="icon3-flickr2"></i></button>
                            <span class="drop-up-sub-nav">
                                <span class="drop-up-item"><a id="ask-a-human-button" title="Ask to a human" target="_blank" class="cancle-chat-btn download-btn" type="button"><i class="icon3-bubbles3"></i></a></span>
                                <span class="drop-up-item"><button title="Give feedback" id="chat-feedback-button" class="cancle-chat-btn download-btn" type="button"><i class="icon3-twitch"></i></button></span>
                                <span class="drop-up-item">
                                <button type="button" style="pointer-events: all !important;" id="download-chat-button" class="cancle-chat-btn download-btn"/><span class="icon2-download2"></span></button>
                                </span>
                            </span>
                        </span>
                    </span>
                </form>
            </div>

        <!-- =========================

            Widget HTML ends here

        ============================ -->
    </div>
    `;
    }

    function makeResizableDiv(div) {
        const widget = document.getElementById('chat-widget');
        const element = widget.shadowRoot.querySelector(div);
        const heightElement = widget.shadowRoot.querySelector(".chats");
        const resizers = widget.shadowRoot.querySelectorAll(div + ' .resizer')
        const minimum_size = 20;
        let original_width = 0;
        let original_height = 0;
        let original_x = 0;
        let original_y = 0;
        let original_mouse_x = 0;
        let original_mouse_y = 0;
        for (let i = 0;i < resizers.length; i++) {
          const currentResizer = resizers[i];
          currentResizer.addEventListener('mousedown', function(e) {
            e.preventDefault()
            original_width = parseFloat(getComputedStyle(element, null).getPropertyValue('width').replace('px', ''));
            original_height = parseFloat(getComputedStyle(heightElement, null).getPropertyValue('height').replace('px', ''));
            original_x = heightElement.getBoundingClientRect().left;
            original_y = heightElement.getBoundingClientRect().top;
            original_mouse_x = e.pageX;
            original_mouse_y = e.pageY;
            window.addEventListener('mousemove', resize)
            window.addEventListener('mouseup', stopResize)
          })
          
          function resize(e) {
            if (currentResizer.classList.contains('top-left')) {
                element.style.maxWidth = "unset";
                const width = original_width - (e.pageX - original_mouse_x)
                const height = original_height - (e.pageY - original_mouse_y)
                if (width > minimum_size) {
                  element.style.width = width + 'px';
                  element.style.minWidth = "400px";
                  // element.style.left = original_x + (e.pageX - original_mouse_x) + 'px'
                }
                if (height > minimum_size) {
                  heightElement.style.height = height + 'px'
                  heightElement.style.maxHeight = '75vh'
                  heightElement.style.minHeight = '300px'
                  // element.style.top = original_y + (e.pageY - original_mouse_y) + 'px'
                }
            }
          }
          
          function stopResize() {
            element.style.maxWidth = element.style.width;
            window.removeEventListener('mousemove', resize)
          }
        }
    }

    function chatBotStyleTemplate(){
        return `

        .disclaimer-chatbot-widget {
            position: absolute;
            bottom: 1px;
            width: 100%;
            text-align: center;
            color: red;        
        }
        /* drop up buttons menu */
        .drop-up {
            display: inline-block;
            padding: 0px;
            list-style: none;
            z-index: 25;
        }
        .drop-up .drop-up-item {
            text-align: center;
            margin: 0 auto;
            width: 120px;
            height: 30px;
            position: relative;
            text-decoration: none;
            font-size: 18px;
            z-index: 25;
        }
        /* subnav layer */
        .drop-up-sub-nav {
            padding: 0px;
            margin: 0px;
            text-align: center;
            list-style: none;
            position: absolute;
            display: none;
            opacity: 0;
            z-index: 30;
            background: #FFFFFF;
            border: 1px solid #F0F0F0;
            box-shadow: 0 -5px 15px 0 rgba(0,0,0,0.12);
        }
        .drop-up-sub-nav .drop-up-item {
            display: block;
            width: 100%;
            background-color: #fff;
            text-align: center;
            z-index: 30;
        }
        .drop-up-sub-nav .drop-up-item button {
            background-color: #fff;
            border: none;
        }
        .drop-up-item:hover .drop-up-sub-nav {
            display: block;
            opacity: 1;
            bottom: 22px;
            text-align: center;
            right: 4px;
            padding: 4px 0px;
            border-radius: 5px;
        }
        [class^="icon3-"], [class*=" icon3-"] {
            /* use !important to prevent issues with browser extensions that change fonts */
            font-family: 'icomoon3' !important;
            speak: never;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
          
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
        .icon3-bubbles3:before {
            content: "\\e96f";
        }
        .icon3-twitch:before {
            content: "\\ea9f";
        }
        .icon3-flickr2:before {
            content: "\\eaa4";
        }
        [class^="icon2-"], [class*=" icon2-"] {
            /* use !important to prevent issues with browser extensions that change fonts */
            font-family: 'icomoon2' !important;
            speak: never;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
          
            /* Better Font Rendering =========== */
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }

        .icon2-copy:before {
            content: "\\e92c";
          }
          .icon2-cloud-check:before {
            content: "\\e9c4";
          }
          .icon2-download2:before {
            content: "\\e9c5";
          }

        .chatbotclosed .resizable {
            max-width: 300px !important;
            min-width: 300px !important;
        }
        .chatbotclosed .resizer.top-left  {
            cursor: pointer !important;
        }
          .resizable .resizers{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
          }
          
          .resizable .resizers .resizer{
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: transparent;
            border: 3px solid transparent;
            position: absolute;
          }
          
          .resizable .resizers .resizer.top-left {
            left: -5px;
            top: -5px;
            cursor: nwse-resize; /*resizer cursor*/
          }
          .resizable .resizers .resizer.top-right {
            right: -5px;
            top: -5px;
            cursor: nesw-resize;
          }
          .resizable .resizers .resizer.bottom-left {
            left: -5px;
            bottom: -5px;
            cursor: nesw-resize;
          }
          .resizable .resizers .resizer.bottom-right {
            right: -5px;
            bottom: -5px;
            cursor: nwse-resize;
          }

        .reaction-container, .selected-reaction {
            position: absolute !important;
        }

        .reaction-container {
            background: #fff;
            z-index: 999;
            padding: 4px 15px;
            max-width: 80%;
            border-radius: 4px;
            box-shadow: 0 0 5px 1px rgb(0 0 0 / 10%);
            clear: both;
            font-family: 'Open Sans', sans-serif;
            line-height: 0;
            color: #212529;
            right: 2%;
        }

        .reaction-container > i {
            padding: 3px;
            cursor: pointer;
            background: transparent;
            font-size: 15px;
        }

        .reaction-container > i:before,
        .selected-reaction > i:before {
            background: #fff;
            border-radius: 5px;
        }

        .reaction-container > i:hover {
            font-size: 20px;
        }

        .reaction-container > i.icon1-happy:hover, 
        .reaction-container > i.icon1-happy.selected,
        .selected-reaction > i.icon1-happy {
            color: green;
        }

        .reaction-container > i.icon1-confused:hover,
        .reaction-container > i.icon1-confused.selected,
        .selected-reaction > i.icon1-confused {
            color: red;
        }
         
  [class^="icon-"], [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'icomoon' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
  
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .icon-reset-update-icon:before {
    content: "\\e900";
  }
  .icon-send-icon:before {
    content: "\\e901";
  }
  .icon-compass:before {
    content: "\\e949";
  }
  .icon-redo:before {
    content: "\\e966";
  }
  .icon-cross:before {
    content: "\\ea0f";
  }
  .icon-checkmark:before {
    content: "\\ea10";
  }

  
[class^="icon1-"], [class*=" icon1-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'icomoon1' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
  
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon1-happy:before {
    content: "\\e9df";
  }
  .icon1-confused:before {
    content: "\\e9f5";
  }
          
        .start-chat-button {
            color: #fff;
            background-color: #00c3ff;
            border-color: #00c3ff;
        }
        .chatbox-avatar {
            overflow: hidden;
            height: 32px;
            width: 32px;
            margin: 0 10px 0 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
        }

        .chatbox-avatar img {
            height: 100%;
            width: 100%;
            vertical-align: middle;
            border: 0;
        }

        .chatbox-header-left {
            display: flex;
            align-items: center;
        }
        .hidetypingtext {
            display: none;
        }
        .typing-text {
            background: transparent;
            position: absolute;
            bottom: 40px;
            left: 15px;
            font-size: 12px;
            line-height: 1.5;
            letter-spacing: .1em;
            color: #00c3ff;
            font-weight: bold;
        }
        .start-chat-button-div {
            display: inline-block !important;
            text-align: center !important;
            width: 100%;
        }

        .online {
        border:1px solid rgb(0, 255, 46);
        background: rgb(0, 255, 46);
        }

        .offline {
            border: 1px solid #EF5350;
            background: #EF5350;
        }
        .circle{
        -webkit-border-radius:8px;
        -moz-border-radius:8px;
        border-radius:8px;
        width:8px !important;
        height:8px !important;
        position: relative;
        display: inline-block;
        margin: 0px 5px;
        bottom: 7px;
        }

        .chatbox-user-name {
            margin-top: 5px;
        }
        .display-none {
        display:none !important;
        }

        @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
        .widget-content {
        border-radius: 6px;
        box-shadow: 0px 0px 20px #acacac;
        font-family: 'Open Sans', sans-serif;
        line-height: 1.5;
        min-width: 200px;
        max-width: 400px;
        }
        .sendMessage {
        background: #ece5dd;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        background-color: white;
        }
        
        .header {
        background: #0088ff;
        color: #fff;
        height: 50px;
        display: table-row;
        line-height: 34px;
        text-align: center;
        }
        h1 {
        padding: 8px 16px;
        }
        .container {
            min-width: 400px;
            height: 100%;
            margin: auto;
            display: table;
            width: 100%
        }
        .header {
        background: #0088ff;
        color: #fff;
        height: 50px;
        display: table-row;
        line-height: 34px;
        text-align: center;
        }
        h1 {
        padding: 8px 16px;
        }
        .chats {
            font-size: 14px;
            padding: 10px 10px 25px 15px;
            overflow-y: scroll;
            overflow-x: hidden;
            background: #f8f7f4 url(https://unpkg.com/evalueserve-chatbot-ui@1.0.21/chatbg.png);            
            max-height: 400px;
            min-height: 400px;
        }

        .btn {
            font-weight: 400;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            border: 1px solid transparent;
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            line-height: 1.5;
            border-radius: 0.25rem;
            transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        }
        .chat-bubble {
            overflow-wrap: break-word;
            word-break: break-word;
            display: inline-block;
            padding: 8px 10px;
            margin: 6px 0px;
            position: relative;
            max-width: 80%;
            border-radius: 4px;
            box-shadow: 0 0 5px 1px rgb(0 0 0 / 10%);
            clear: both;
            font-family: 'Open Sans', sans-serif;
            line-height: 1.5;
            color: #212529;
            font-size: 1rem;
            cursor: default;
        }
        .msg-in {
        background: #fff;
        text-align: left;
        float: left;
        }
        .msg-out {
        background: #dcf8c6;
        text-align: left;
        float: right;
        }
        .msg-in::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        left: -6px;
        top: 0;
        border: 10px solid transparent;
        border-top-color: #fff;
        }
        .msg-in::after {
        content: attr(data-time);
        font-size: 12px;
        color: #8a8a8a;
        position: relative;
        margin: 4px;
        float: right;
        bottom: -6px;
        right: -8px;
        }
        .msg-out::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        right: -6px;
        top: 0;
        border: 10px solid transparent;
        border-top-color: #dcf8c6;
        }
        .msg-out::after {
        content: attr(data-time);
        font-size: 12px;
        color: #8a8a8a;
        position: relative;
        margin: 4px;
        margin-right: 25px;
        float: right;
        bottom: -6px;
        right: -8px;
        }
        
        .read::before {
        border-color: transparent #0088ff #0088ff transparent;
        }
        .read::after {
        border-color: transparent #0088ff #0088ff transparent;
        }
        .delivered::before {
        border-color: transparent grey grey transparent;
        }
        .delivered::after {
        border-color: transparent grey grey transparent;
        }
        .sent::before {
        border-color: transparent grey grey transparent;
        }

        /* =======  widget styles ========= */
        /* ======= style for movement ======== */
        .draggable{
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            position: fixed;
            bottom: 20px;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: rgb(0 0 0 / 40%) 0px 30px 90px;
            z-index: 9999;
            right: 2%;
            border-color: rgb(242, 242, 242);
            border-width: 0px;
            border-style: solid solid none;
        }

        /* ======= style for resizable ======= */
        .resizers{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
        }
        
        .resizers .resizer{
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: white;
        border: 3px solid #4286f4;
        position: absolute;
        }

        .minimise-chat {
        display: none;
        }

        /* =======  widget styles ========= */
        .titlebar {
            
            color: white;
            height: 32px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
            background: #00c3ff;
            min-width: 100px;
            cursor: pointer !important;
            font-size: 11pt;
            line-height: 28px;
            text-align: center;
            width: 100%;            
        }
        
        .buttons {
            padding-left: 8px;
            padding-top: 3px;
            float: left;
            line-height: 0px;
        }
        
        .buttons:hover a {
            visibility: visible;
        }
        
        .close {
            background: #ff5c5c;
            font-size: 9pt;
            width: 11px;
            height: 11px;
            border: 1px solid #e33e41;
            border-radius: 50%;
            display: inline-block;
            cursor:pointer;
            line-height:11px;
            text-align:center;
            margin-left:3px;
        }
        
        .close:hover {
            background: #c14645;
            border: 1px solid #b03537;
        }
                
        .zoom {
            background: #00ca56;
            font-size: 9pt;
            line-height: 11px;
            margin-left: 6px;
            width: 11px;
            height: 11px;
            border: 1px solid #14ae46;
            border-radius: 50%;
            display: inline-block;
            cursor:pointer
        }
        
        .zoom:hover {
            background: #029740;
            border: 1px solid #128435;
        }
        
        .content {
            padding: 10px;
        }

        #widget-content{
            background: #fff;
            width: 100%;
            height: 100%;
            border-radius: 6px;
            box-shadow: 0px 0px 20px #acacac;
        }
        #task-input{
            width:70%;
        }

        ::-webkit-scrollbar {
            height: 12px;
            width: 7px;
            background: transparent;
        }
        
        ::-webkit-scrollbar-thumb {
            background: #424242;
            -webkit-border-radius: 1ex;
            -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
        }
        
        ::-webkit-scrollbar-corner {
            background: #424242;
        }

        .input-option {
            background: #00c3ff;
            margin: 4px;
            cursor: pointer;
            font-size: 14px;
            line-height: 18px;
            padding: 10px;
            border-radius: 6px;
            background-color: rgb(242, 242, 243);
            color: rgb(32, 33, 35);
            display: inline-block;
        }

        .input-option:hover {
            background-color: rgb(32, 33, 35);
            color: rgb(255, 255, 255);
        }
        .disable-form {
            pointer-events: none;
            background: #F5F5F5 !important;
        }

        .disable-form input {
            background: #F5F5F5 !important;
        }

        .disable-form button{
            color: #9E9E9E !important;
        }
        
        .send-message-btn{
            border: none;
            outline: none;
            background: transparent;
            cursor: pointer;
            font-size: 12px;
            padding: 6px 9px;
            border-radius: 6px;
            color: #29B6F6;
            display: inline-block;
            font-weight: bold;
        }

        .send-message-btn:hover {
            background: #039BE5;
            color: #fff;
        }

        .cancle-chat-btn:hover {
            background: #EF5350 !important;
            color: #fff !important;
        }

        .cancle-chat-btn.download-btn:hover {
            background: #EF6C00 !important;
            color: #fff !important;
        }

        .cancle-chat-btn {
            border: none;
            outline: none;
            background: transparent;
            margin: 4px;
            cursor: pointer;
            font-size: 12px;
            padding: 6px 9px;
            border-radius: 6px;
            color: #EF5350;
            display: inline-block;
            font-weight: bold;
        }

        .send-message-to-hr-btn{
            position: absolute;
            top: -9px;
            right: 2%;
            border: none;
            outline: none;
            background: #FF9800;
            cursor: pointer;
            font-size: 10px;
            padding: 1px 5px;
            border-radius: 6px;
            color: #fff;
            display: inline-block;
            font-weight: bold;
            text-decoration: none;
        }

        .send-message-to-hr-btn:hover {
            background: #FB8C00;
        }

        #chatbot-title-name {
            max-width: 200px;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        `;
    }

    function initChatBot(){
        let html = chatBotTemplate();    
    
        let shadowStyle = document.createElement("style");
    
        shadowStyle.textContent = chatBotStyleTemplate();
    
        // not use window.onload as it will override other mehtods instead adding new listner
        // window.addEventListener('load', function () {
            // Create container div and append it to body
            let container = document.createElement('div');        
            container.setAttribute("class", "draggable");
            container.setAttribute("id", "chat-widget");
            container.innerHTML = ``;
    
            if(document.getElementById('chat-widget')){
                return;
            }
            
            document.getElementById('chatwidget-root').appendChild(container);
    
            const shadow = container.attachShadow({ mode: "open" });
            shadow.appendChild(shadowStyle)
    
            let chatHtml = document.createElement('div');        
            chatHtml.setAttribute("class", "draggable");
            chatHtml.setAttribute("id", "tarun-chat-widget");
            chatHtml.innerHTML = html;
            shadow.appendChild(chatHtml);
    
            let chatBotWidgetParent = document.getElementById('chat-widget');
            let chatbotForm = chatBotWidgetParent.shadowRoot.querySelector('form');
            let chatTitleBar = chatBotWidgetParent.shadowRoot.querySelector('#chat-titlebar');
            let chatContainer = chatBotWidgetParent.shadowRoot.querySelector('#chat-container');
            let chatConnectivityStatus = chatBotWidgetParent.shadowRoot.querySelector('#connectivity-status');
            let typingtextHint = chatBotWidgetParent.shadowRoot.getElementById('typing-text');
            let downloadChatButton = chatBotWidgetParent.shadowRoot.querySelector("#download-chat-button")
            let chatsHidden = chatBotWidgetParent.shadowRoot.querySelector("#chats-hidden");
            let askHumanButton = chatBotWidgetParent.shadowRoot.querySelector("#ask-a-human-button")
            
            chatTitleBar.addEventListener('click', () => {
                chatContainer.classList.toggle("display-none");

                if(chatContainer.classList.contains("display-none")){
                    chatHtml.classList.add("chatbotclosed");
                    chatHtml.classList.remove("chatbotopened");
                }else{
                    chatHtml.classList.add("chatbotopened");
                    chatHtml.classList.remove("chatbotclosed");
                }
            })
    
            // ============== Widget code ends ======================
    
            let socket = null;
            let unique = null;
    
            chatTitleBar.addEventListener('click', () => {
    
                if(!socket && !chatContainer.classList.contains('display-none')){
                    socket = io(socketData?.url,  {
                        query: loginDetails,
                        transports: ['websocket'],
                        path: socketData?.path
                    })
    
                    const scrollToBottom = (id) => {
                        const element = chatBotWidgetParent.shadowRoot.querySelector(id);
                        element.scrollTop = element.scrollHeight + 2000;
                    }
    
                    function pushMessageInWithTypingEffect(message){
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.innerHTML = ``;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        
                        var typewriter = new Typewriter(newMessageIn, {
                            loop: false,
                            delay: 0,
                            cursor: ""
                        });
    
                        typewriter
                        .typeString(message)
                        .start();
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }
                    
                    function pushMessageIn(message, sendMail = 0, prevQuestion){
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.innerHTML = `${message}`;
                        
                        if(sendMail){
                            let sendEmailPlug = document.createElement('a'); 
                            sendEmailPlug.innerHTML = `Email to HR`;
                            sendEmailPlug.setAttribute('class', 'send-message-to-hr-btn')
                            sendEmailPlug.setAttribute('target', '_blank');
                            sendEmailPlug.setAttribute('href', `mailto:hr@evalueserve.com?subject=question&body=${prevQuestion}`)
                            newMessageIn.appendChild(sendEmailPlug);
                        }
                        
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }
            
                    function pushMessageOut(message){
                        let newMessageOut = document.createElement('p');        
                        newMessageOut.setAttribute("class", "chat-bubble msg-out");
                        newMessageOut.innerHTML = `${message}`;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageOut);
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }
                    // client-side
                    socket.on("connect_error", (err) => {
                        // if(err instanceof Error){
                        //     pushMessageIn(err.message);
                        // }
                        console.log(socketData?.url)
                        console.log(err)
                        console.log(err instanceof Error); // true
                        console.log(err.message); // not authorized
                    });

                    function pushMessageInWithTypingEffectWithInsideEvent(message){
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.innerHTML = ``;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        
                        var typewriter = new Typewriter(newMessageIn, {
                            loop: false,
                            delay: 0,
                            cursor: ""
                        });
    
                        typewriter
                        .typeString(message)
                        .callFunction(() => {
                            socket.emit('register',unique); 
                            scrollToBottom('#chats')
                        })
                        .start();
                    }

                    function getMailContent(){
                        if(document.getElementById('chat-widget')){
                            return document.getElementById('chat-widget').shadowRoot.querySelector("#chats-hidden").innerHTML
                        }else{
                            return ""
                        }
                    }

                    socket.on('botDetailMessage', ({message, sessionId}) => {
                        setTimeout(() => {
                            pushMessageInWithTypingEffectWithInsideEvent(message)
                        }, 1000, message)
                    })

                    socket.on("downloadScreenshot", (disclaimer)  => {
                        let chatsScreen = chatBotWidgetParent.shadowRoot.querySelector('#chats');
                        html2canvas(chatsScreen,{
                            onclone: function(clone) {
                                let cloned = clone.getElementById('chat-widget').querySelector('#chats')
                                cloned.style.overflowY = "auto";
                                cloned.style.overflowX = "auto";
                                cloned.style.maxHeight = "unset";
                                cloned.style.minHeight = "unset";
                                cloned.style.height = "unset";
                                let disclaimerP = document.createElement('p');        
                                disclaimerP.setAttribute("class", "disclaimer-chatbot-widget");
                                // chatHtml.setAttribute("id", "tarun-chat-widget");
                                disclaimerP.innerHTML = disclaimer;
                                disclaimerP.style.color = "red";
                                disclaimerP.style.display = "inline-block";
                                disclaimerP.style.position = "relative";
                                disclaimerP.style.width = "100%";
                                cloned.appendChild(disclaimerP);
                                return true;
                            }
                        }).then(canvas => {
                            canvas2image.saveAsPNG(canvas)
                        });
                    })
            
                    // socket connection message
                    socket.on('connected', ({message, sessionId, botName}) => {
                        chatBotWidgetParent.shadowRoot.querySelector('#chatbot-title-name').innerHTML = `${botName}`;
                        unique = sessionId;
                        setTimeout(() => {
                            pushMessageInWithTypingEffect(message)
                        }, 1000, message)
                        
                        chatConnectivityStatus.classList.remove('offline')
                        chatConnectivityStatus.classList.add('online') 
                    })
            
                    socket.on('disconnect', (message) => {
                        pushMessageIn('Chatbot is disconnected !');
                        hideChatBotForm();
                        typingtextHint.classList.add('hidetypingtext');
                        chatConnectivityStatus.classList.add('offline')
                        chatConnectivityStatus.classList.remove('online')
                    })
            
                    socket.on('sessionCreated', (data) => {
                        const {message, options, sessionId} = data;
                        setTimeout(() => {
                            pushMessageInWithTypingEffect(message);
                        }, 1000, message)
    
                        setTimeout(() => {
                            pushDepartmentOptionsIn(options,sessionId);
                        }, 2000, options,sessionId)                    
                    })

                    socket.on('dir:sessionCreated', (data) => {
                        const {message, options, sessionId} = data;
                        setTimeout(() => {
                            pushMessageInWithTypingEffect(message);
                        }, 1000, message)
    
                        setTimeout(() => {
                            pushDIRDepartmentOptionsIn(options,sessionId);
                        }, 2000, options,sessionId)                    
                    })

                    downloadChatButton.addEventListener('click', () => {
                        socket.emit("downloadScreenshot")
                    });

                    socket.on("dir:systemgenerated:sessionCreated", (data) => {
                        const {message, options, sessionId} = data;

                        setTimeout(() => {
                            pushMessageInWithTypingEffect(message);
                        }, 1000, message)

                        setTimeout(() => {
                            pushSystemGeneratedOptionsObjectIn(options,sessionId);
                        }, 2000, options,sessionId) 
                    })

                    function pushSystemGeneratedOptionsObjectIn(options, sessionId){
                        let result = options.map((option,index) => `<span id="department-input-option${index}${sessionId}" uniqueName="${option.value}" uniqueId="${option._id}" class="input-option department-input-options">${option.value}</span>`);
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.setAttribute("id", "department-input-p");
                        newMessageIn.innerHTML = `${result.join(' ')}`;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        for (var i = 0; i < options.length; i++) {
                            chatBotWidgetParent.shadowRoot.querySelector(`#department-input-option${i}${sessionId}`).addEventListener('click', function(e) {
                                socket.emit('dir:departmentChange',{sessionId:unique, department: e.target.getAttribute('uniqueId'), departmentName: e.target.getAttribute('uniqueName')}); 
                                pushMessageOut(e.target.innerHTML)
                                const departmentInputParagraph = chatBotWidgetParent.shadowRoot.querySelector('#department-input-p')
    
                                if(departmentInputParagraph){
                                    chatBotWidgetParent.shadowRoot.querySelector('#chats').removeChild(departmentInputParagraph);
                                }
                            }, false);
                        }
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }

                    chatBotWidgetParent.shadowRoot.querySelector(`#chat-feedback-button`).addEventListener('click', (e) => {
                        socket.emit('dir:departmentChange',{sessionId:unique, department: "Feedback", departmentName: "Feedback"}); 
                        pushMessageOut('Feedback')
                        const departmentInputParagraph = chatBotWidgetParent.shadowRoot.querySelector('#department-input-p')

                        if(departmentInputParagraph){
                            chatBotWidgetParent.shadowRoot.querySelector('#chats').removeChild(departmentInputParagraph);
                        }
                    })

                    function pushDIRDepartmentOptionsIn(options, sessionId){
                        let result = options.map((option,index) => `<span id="department-input-option${index}${sessionId}" class="input-option department-input-options">${option}</span>`);
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.setAttribute("id", "department-input-p");
                        newMessageIn.innerHTML = `${result.join(' ')}`;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        for (var i = 0; i < options.length; i++) {
                            chatBotWidgetParent.shadowRoot.querySelector(`#department-input-option${i}${sessionId}`).addEventListener('click', function(e) {
                                socket.emit('dir:departmentChange',{sessionId:unique, department: e.target.innerHTML}); 
                                pushMessageOut(e.target.innerHTML)
                                const departmentInputParagraph = chatBotWidgetParent.shadowRoot.querySelector('#department-input-p')
    
                                if(departmentInputParagraph){
                                    chatBotWidgetParent.shadowRoot.querySelector('#chats').removeChild(departmentInputParagraph);
                                }
                            }, false);
                        }
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }
            
                    socket.on('onLocationOptions', (data) => {
                        const {message,options, sessionId} = data;
    
                        setTimeout(() => {
                            pushMessageInWithTypingEffect(message);
                        }, 1000, message)
    
                        setTimeout(() => {
                            pushLocationOptionsIn(options,sessionId);
                        }, 2000, message)
                    })

                    socket.on('onDeepLocationOptions', (data) => {
                        const {message,options,sessionId} = data;
    
                        setTimeout(() => {
                            pushMessageInWithTypingEffect(message);
                        }, 1000, message)
    
                        setTimeout(() => {
                            pushDeepLocationOptionsIn(options,sessionId);
                        }, 2000, message)
                    })

                    socket.on('onHRTopicsOptions', (data) => {
                        const {message,options,sessionId} = data;

                        setTimeout(() => {
                            pushMessageInWithTypingEffect(message);
                        }, 1000, message)

                        setTimeout(() => {
                            pushTopicsOptionsIn(options,sessionId);
                        }, 2000, message)
                    })
            
                    socket.on('inputsSuccess', (message) => {
                        pushMessageInWithTypingEffect(message);
                        showChatBotForm();
                    })

                    socket.on('on:feedbackSaved', (message) => {
                        pushMessageIn(message)
                    })  

                    socket.on('optionDescription', (message) => {
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.innerHTML = ``;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        
                        var typewriter = new Typewriter(newMessageIn, {
                            loop: false,
                            delay: 0,
                            cursor: ""
                        });
    
                        typewriter
                        .typeString(message)
                        .callFunction(() => {
                            socket.emit("dir:showInputSuccess", {})
                        })
                        .start();
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    })
    
                    function showChatBotForm(){
                        chatBotWidgetParent.shadowRoot.querySelector('#chatbotform').classList.remove('disable-form');
                        chatBotWidgetParent.shadowRoot.querySelector('#chatbotform input').focus();
                    }
    
                    function hideChatBotForm(){
                        chatBotWidgetParent.shadowRoot.querySelector('#chatbotform').classList.add('disable-form');
                        chatBotWidgetParent.shadowRoot.querySelector('#chatbotform input').blur();
    
                    }

                    function pushTopicsOptionsIn(options, sessionId){
                        let result = options.map((option,index) => `<span id="topics-input-option${index}${sessionId}" class="input-option department-input-options">${option}</span>`);
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.setAttribute("id", "topics-input-p");
                        newMessageIn.innerHTML = `${result.join(' ')}`;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        
                        for (var i = 0; i < options.length; i++) {
                            chatBotWidgetParent.shadowRoot.querySelector(`#topics-input-option${i}${sessionId}`).addEventListener('click', function(e) {
                                socket.emit('onTopicChange',{sessionId:unique, location: e.target.innerHTML}); 
                                pushMessageOut(e.target.innerHTML)
    
                                const locationInputParagraph = chatBotWidgetParent.shadowRoot.querySelector('#topics-input-p')
    
                                if(locationInputParagraph){
                                    chatBotWidgetParent.shadowRoot.querySelector('#chats').removeChild(locationInputParagraph);
                                }
                            }, false);
                        }
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }
            
                    function pushLocationOptionsIn(options, sessionId){
                        let result = options.map((option,index) => `<span id="location-input-option${index}${sessionId}" class="input-option department-input-options">${option}</span>`);
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.setAttribute("id", "location-input-p");
                        newMessageIn.innerHTML = `${result.join(' ')}`;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        
                        for (var i = 0; i < options.length; i++) {
                            chatBotWidgetParent.shadowRoot.querySelector(`#location-input-option${i}${sessionId}`).addEventListener('click', function(e) {
                                socket.emit('onLocationChange',{sessionId:unique, location: e.target.innerHTML}); 
                                pushMessageOut(e.target.innerHTML)
    
                                const locationInputParagraph = chatBotWidgetParent.shadowRoot.querySelector('#location-input-p')
    
                                if(locationInputParagraph){
                                    chatBotWidgetParent.shadowRoot.querySelector('#chats').removeChild(locationInputParagraph);
                                }
                            }, false);
                        }
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }

                    function pushDeepLocationOptionsIn(options, sessionId){
                        let result = options.map((option,index) => `<span id="deep-location-input-option${index}${sessionId}" class="input-option department-input-options">${option}</span>`);
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.setAttribute("id", "deep-location-input-p");
                        newMessageIn.innerHTML = `${result.join(' ')}`;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        
                        for (var i = 0; i < options.length; i++) {
                            chatBotWidgetParent.shadowRoot.querySelector(`#deep-location-input-option${i}${sessionId}`).addEventListener('click', function(e) {
                                socket.emit('onDeepLocationChange',{sessionId:unique, location: e.target.innerHTML}); 
                                pushMessageOut(e.target.innerHTML)
    
                                const locationInputParagraph = chatBotWidgetParent.shadowRoot.querySelector('#deep-location-input-p')
    
                                if(locationInputParagraph){
                                    chatBotWidgetParent.shadowRoot.querySelector('#chats').removeChild(locationInputParagraph);
                                }
                            }, false);
                        }
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }
            
                    function pushDepartmentOptionsIn(options, sessionId){
                        let result = options.map((option,index) => `<span id="department-input-option${index}${sessionId}" class="input-option department-input-options">${option}</span>`);
                        let newMessageIn = document.createElement('p'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.setAttribute("id", "department-input-p");
                        newMessageIn.innerHTML = `${result.join(' ')}`;
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        for (var i = 0; i < options.length; i++) {
                            chatBotWidgetParent.shadowRoot.querySelector(`#department-input-option${i}${sessionId}`).addEventListener('click', function(e) {
                                socket.emit('departmentChange',{sessionId:unique, department: e.target.innerHTML}); 
                                pushMessageOut(e.target.innerHTML)
                                const departmentInputParagraph = chatBotWidgetParent.shadowRoot.querySelector('#department-input-p')
    
                                if(departmentInputParagraph){
                                    chatBotWidgetParent.shadowRoot.querySelector('#chats').removeChild(departmentInputParagraph);
                                }
                            }, false);
                        }
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }
            
                    socket.on('showTypingText', (message) => {
                        typingtextHint.classList.remove('hidetypingtext');
                        hideChatBotForm();
                    })
            
                    socket.on('hideTypingText', (message) => {
                        typingtextHint.classList.add('hidetypingtext');
                        showChatBotForm()
                    })

                    function pushMessageInPrivateMessage(message, sendMail = 0, prevQuestion, messageId, email= ""){
                        let newMessageIn = document.createElement('div'); 
                        newMessageIn.setAttribute("class", "chat-bubble msg-in");
                        newMessageIn.innerHTML = `${message}`;
                        
                        if(sendMail){
                            let sendEmailPlug = document.createElement('a'); 
                            sendEmailPlug.innerHTML = `Email`;
                            sendEmailPlug.setAttribute('class', 'send-message-to-hr-btn')
                            sendEmailPlug.setAttribute('target', '_blank');
                            sendEmailPlug.setAttribute('href', `mailto:${email}?body=${prevQuestion}`)
                            newMessageIn.appendChild(sendEmailPlug);
                        }

                        let reactionContainer = document.createElement('div'); 
                        reactionContainer.setAttribute('class', 'reaction-container display-none')
                        let happyReaction = document.createElement('i');
                        happyReaction.setAttribute('class', 'icon1-happy')
                        let confusedReaction = document.createElement('i');
                        confusedReaction.setAttribute('class', 'icon1-confused')

                        reactionContainer.appendChild(happyReaction)
                        reactionContainer.appendChild(confusedReaction)
                        newMessageIn.appendChild(reactionContainer)

                        let selectedReaction = document.createElement('div'); 
                        selectedReaction.setAttribute('class', 'selected-reaction')
                        newMessageIn.appendChild(selectedReaction)

                        let reaction = document.createElement('i')
                        reaction.setAttribute('class', 'display-none')
                        selectedReaction.appendChild(reaction)

                        happyReaction.addEventListener('click', (e) => {
                            reaction.setAttribute('class', 'icon1-happy reaction')
                            if(messageId){
                                socket.emit('onMessageReact', {reaction: "Happy", messageId})
                            }
                            
                            reactionContainer.classList.add('display-none')
                        })

                        confusedReaction.addEventListener('click', (e) => {
                            reaction.setAttribute('class', 'icon1-confused reaction')

                            if(messageId){
                                socket.emit('onMessageReact', {reaction: "Confused", messageId})
                            }
                            
                            reactionContainer.classList.add('display-none')
                        })

                        function mouseoverHandler(e){
                            reactionContainer.classList.remove('display-none')
                        }

                        function mouseoutHandler(e){
                            reactionContainer.classList.add('display-none')
                        }

                        newMessageIn.addEventListener('mouseover', mouseoverHandler)

                        newMessageIn.addEventListener('mouseout', mouseoutHandler)
                        
                        chatBotWidgetParent.shadowRoot.querySelector('#chats').appendChild(newMessageIn);
                        
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    }

                    socket.on("emailSentEvent", (message) => {
                        askHumanButton.parentElement.style.display = "initial";
                        pushMessageIn(message)
                    })
            
                    /*Received private messages*/
                    socket.on('private_chat',function(data){
                        let {message, sendMail, prevQuestion, messageId,chatbotEmail } = data;
                        
                        chatsHidden.innerHTML += `<br/><strong>Answer</strong>: ${message} <br/>`;
                        
                        pushMessageInPrivateMessage(message, sendMail, prevQuestion, messageId,chatbotEmail);
                        setTimeout(() => {
                            scrollToBottom('#chats')
                        },500);
                    });
    
                    socket.on('quitChat', function(data){
                        disconnectChat();
                    })
    
                    function disconnectChat(){
                        socket.emit('quitChat');
                        socket = null
                        hideChatBotForm();
                        typingtextHint.classList.add('hidetypingtext');
                        setTimeout(() => {
                            // chatContainer.classList.add("display-none");
                            chatTitleBar.click()
                            chatBotWidgetParent.shadowRoot.querySelector('#chats').replaceChildren();
                        }, 2000)
                    }

                    function resetChat(){
                        hideChatBotForm();
                        socket.emit('resetChat', unique);
                    }

                    chatBotWidgetParent.shadowRoot.querySelector('#reset-chat-button').addEventListener('click', (e) => {
                        resetChat();
                    })
    
                    chatBotWidgetParent.shadowRoot.querySelector("#disconnect-chat-button").addEventListener('click', (e) => {
                        disconnectChat();
                    });

                    askHumanButton.addEventListener('click', (e) => {
                        askHumanButton.parentElement.style.display = "none";
                        socket.emit('forwardToHuman', chatsHidden.innerHTML);
                    })
            
                    chatbotForm.addEventListener('submit', (e) => {
                        e.preventDefault()
                        
                        let message = e.target.querySelector('input').value
                    
                        if(!message.length){
                        return;
                        }
            
                        pushMessageOut(message)
                        chatsHidden.innerHTML += `<br/> <strong>Question</strong>: ${message}` 
                        chatbotForm.reset();
            
                        socket.emit('private_chat',{
                        to : unique,
                        message
                        }, (error) => {
            
                        if(!error){
                            console.log('Message delivered!');
                        }
                        });
                    })
                }
    
                
            });
    }

    initChatBot();
    makeResizableDiv('.resizable');
}

export default chatbot;